import { STORAGE_KEYS } from "@/zustand/storage-keys";

export type Getter<T> = () => T;
export type Setter<T> = (newData: T) => void;
export type StoreState<T> = BaseState<T> & BaseActions<T>;

export type StorageKeysType = typeof STORAGE_KEYS;

export interface BaseState<T> {
  data: T;
  isLoading: boolean;
  error: string | null;
}

export const STORAGE_UPDATE_TYPE = {
  MERGE: "merge",
  REPLACE: "replace",
} as const;

export type UpdateStrategy =
  (typeof STORAGE_UPDATE_TYPE)[keyof typeof STORAGE_UPDATE_TYPE];

export interface BaseActions<T> {
  getData: () => T;
  setData: (newData: T) => void;
  updateData: (partialData: Partial<T>, strategy: UpdateStrategy) => void;
  clearData: () => void;
  setLoading: (isLoading: boolean) => void;
  setError: (error: string | null) => void;
}
